import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export const ProtectedRoute = ({ children }) => {
  const { session, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-plai-bg">
        <div className="font-headings text-plai-cta tracking-[0.3em] text-sm">LOADING</div>
      </div>
    );
  }
  if (!session) return <Navigate to="/auth" replace />;
  return children;
};

export default ProtectedRoute;
